<template>
  <div>
    <card-my-incidents-table />
  </div>
</template>
<script>
/* 
  Class: MyIncidents
  Description: This class representing a main entry point for user incidents.
*/

/* Imports */
import CardMyIncidentsTable from "@/components/Cards/Incidents/CardMyIncidentsTable.vue";
/* /Imports/ */

export default {
  /* 
    Define different meta options. 
  */
  metaInfo() {
    return {
      title: this.$appName,
      titleTemplate: "%s | " + this.$route.name,
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    CardMyIncidentsTable
  }
};
</script>
